<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      
      <!-- 电子面单 -->
      <el-dialog title="生成电子面单" :visible.sync="view" width="60%" top="5vh" :before-close="closeshipping">
            <div class="YTO-model-temps" style="text-align:left;margin-bottom:20px;display:inline-block;width:100%;">
                <el-form :inline="true" class="demo-form-inline" size="small">
                    <el-form-item label="高度" label-width="140" style="width:25%">
                        <el-input v-model="printheight" @blur="changeprintheight">
                            <template slot="append">mm</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="垂直边距" label-width="140" style="width:25%">
                        <el-input v-model="printmargintop" @blur="changeprinttop">
                            <template slot="append">px</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="水平边距" label-width="140" style="width:25%">
                        <el-input v-model="printpadding" @blur="changeprintpadding">
                            <template slot="append">px</template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div style="text-align:left;margin-bottom:20px;display:inline-block;width:49%;">
                <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">当订单中只有少量商品时可直接将商品信息<br/>打印在面单上直接拿着面单找货无需再打印拣货单与出库单</div>
                    <el-checkbox v-model="isprintgoods">是否将商品打印到面单上</el-checkbox>
                </el-tooltip>
            </div>
            <div style="text-align:right;margin-bottom:20px;display:inline-block;width:50%;">
                <el-button type="" size="small" round  @click="closeshipping">取 消</el-button>
                <el-button type="primary" size="small" round  @click="printshippinglists" >打 印</el-button>
            </div>
            <el-table :data="selllogisticslists"  style="width: 100%" v-loading="query.loading">
                <el-table-column type="expand">
		            <template slot-scope="props">
		                <el-table :data="props.row.shippings">
			                <el-table-column label="快递信息">
								<template slot-scope="nprops">
									<div class="print-shipping-documents">{{nprops.row.logisticsname}} （{{nprops.row.code}}）</div>
								</template>
							</el-table-column>
                            <el-table-column label="寄件信息" width="180" align="left">
								<template slot-scope="nprops">
                                    <div class="shipping-print-infos" @click="getaddressinfos(props.row.id,nprops.row.id,'send')">
                                        <span class="print-shipping-documents">{{nprops.row.sendname}}，{{nprops.row.sendphone}}</span>
                                        <span class="print-shipping-documents">{{nprops.row.sendProvincename}}-{{nprops.row.sendCityname}}-{{nprops.row.sendArea}}</span>
                                        <span class="print-shipping-documents">{{nprops.row.sendAddress}}</span>
                                    </div>
								</template>
							</el-table-column>
                            <el-table-column label="收件信息" width="180" align="left">
								<template slot-scope="nprops">
                                    <div class="shipping-print-infos" @click="getaddressinfos(props.row.id,nprops.row.id,'recieve')">
                                        <span class="print-shipping-documents">{{nprops.row.recievename}}，{{nprops.row.recievephone}}</span>
                                        <span class="print-shipping-documents">{{nprops.row.recieveProvincename}}-{{nprops.row.recieveCityname}}-{{nprops.row.recieveArea}}</span>
                                        <span class="print-shipping-documents">{{nprops.row.recieveAddress}}</span>
                                    </div>
								</template>
							</el-table-column>
                            <el-table-column label="操作" align="center" width="100">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini" round @click="delshippings(props.row.id,scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
		                </el-table>
		            </template>
	            </el-table-column>
				<el-table-column label="销售单" align="left">
                    <template slot-scope="scope">
                        <div class="print-shipping-documents">{{scope.row.documents}}（{{scope.row.type}}）</div>
                        <div class="print-shipping-id">ID：{{scope.row.id}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="sku数量" align="center">
                    <template slot-scope="scope">
                        <div class="print-shipping-documents">{{scope.row.skucounts}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="实付金额" align="center">
                    <template slot-scope="scope">
                        <div class="print-shipping-documents">{{scope.row.real}}</div>
                    </template>
                </el-table-column>
		        <el-table-column label="操作" align="center" width="180">
		        	<template slot-scope="scope">
						<el-button type="warning" size="mini" round @click="addlogisticstosells(scope.row)">新增快递</el-button>
                        <el-button type="danger" size="mini" round @click="delsells(scope.row)">删除</el-button>
					</template>
		        </el-table-column>
	      	</el-table>
            <div style="text-align:right;margin-top:20px;">
                <el-button type="" size="small" round  @click="closeshipping" >取 消</el-button>
                <el-button type="primary" size="small" round  @click="printshippinglists" >打 印</el-button>
            </div>
      </el-dialog>


      <!-- 选择快递方式 -->
      <el-dialog title="选择快递" :visible.sync="showbirld.dialog" width="25%" top="20vh">
            <el-select v-model="showbirld.id" clearable placeholder="请选择快递公司" size="small">
			    <el-option v-for="(item,index) in birldlists" :label="item.shippingname+'（'+item.shippingcode+'）'" :value="item.id" :key="index"></el-option>
			</el-select>
            <div style="text-align:right;margin-top:20px;">
                <el-button type="" size="small" round  @click="showbirld.dialog=false" >取 消</el-button>
                <el-button type="primary" size="small" round  @click="sellselectshipping" >确 认</el-button>
            </div>
      </el-dialog>


      <!-- 选择快递方式 -->
      <el-dialog title="待打印快递面单" :visible.sync="printbirldsinfos.dialog" width="25%" top="20vh">
            <el-select v-model="printbirldsinfos.logisticsid" clearable placeholder="请选择待打印的快递面单" size="small">
			    <el-option v-for="(item,index) in printbirlds" :label="item.name+'（'+item.code+'）'" :value="item.id" :key="index"></el-option>
			</el-select>
            <div style="text-align:right;margin-top:20px;">
                <el-button type="" size="small" round  @click="printbirldsinfos.dialog=false" >取 消</el-button>
                <el-button type="primary" size="small" round  @click="shippingprint" >确 认</el-button>
            </div>
      </el-dialog>



      <!-- 地址智能识别 -->
      <el-dialog title="智能识别地址" :visible.sync="changeDialog" width="30%" top="20vh">
          <el-input type="textarea" v-model="logisticsname" rows="5" size="small" round placeholder="请输入地址信息，如：张三，133077110988，上海-上海市-闵行区 都市路388弄b区102号" />
          <div style="display:inline-block;width:100%;margin-top:10px;text-align:right">
              <el-button type="primary" size="mini" round @click="analasyaddress">解析</el-button>
          </div>
      </el-dialog>



      <!-- 快递模板（圆通模板1） -->
      <YTO_model1 v-model="YTO_model1" :data="YTO_model1_data" @close="YTO_model_close" /> 
      <!-- 快递模板（中通模板1）-->
      <ZTO_model1 v-model="ZTO_model1" :data="ZTO_model1_data" @close="ZTO_model_close" /> 

      

  </div>
  </transition>
</template>

<script>
//快递模板
import YTO_model1 from '@/components/home/print/YTO_model1' //圆通打印模板
import ZTO_model1 from '@/components/home/print/ZTO_model1' //中通打印模板

import QRCode from 'qrcodejs2'
export default {
  props:['value'],
  components: {QRCode,YTO_model1,ZTO_model1},
  data () {
    return {
      url:this.GLOBAL.domain+"Sellshippingbirld/index",
      transitionshow:true,
      actionauth:[],
      view:false,

      query: {
          act:'getselltologistics',
          token:this.$cookies.get('token'),
          sortorderid:'',
          sellids:'',
          loading:false,
      },
      selllogisticslists:[],
      
      sellid:'',
      logisticsid:'',
      type:'',
      changeDialog:false,
      logisticsname:'',
      isprintgoods:false,

      YTO_model1:false,
      YTO_model1_data:[],
      ZTO_model1:false,
      ZTO_model1_data:[],

      printheight:this.$cookies.get('printsetheight') > 0 ? this.$cookies.get('printsetheight') : 105,
      printmargintop:this.$cookies.get('printsetmargintop') > 0 ? this.$cookies.get('printsetmargintop') : 0,
      printpadding:this.$cookies.get('printpadding') > 0 ? this.$cookies.get('printpadding') : 0,

      birldlists:[],
      showbirld: {
          dialog:false,
          id:'',
          printid:'',
      },

      printbirlds:[],
      printbirldsinfos: {
          dialog:false,
          logisticsid:'',
      },

      
    }  
  },

  watch: {
      value(val) {
          if (val) {
              this.view=true;
              this.query.sortorderid=this.value;
              this.query.sellids='';
              this.getsellandorders();

              this.getbirldinfos(); //获取快递服务商信息列表

          }
      },

  },
  
  methods:{


      //获取快递服务商信息列表
      getbirldinfos() {
          var resource = this.$resource(this.url);
          resource.save({act:'getmyshippings',token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.birldlists=JSON.parse(Base64.decode(res.data.Data));
              }
          }).catch((res) => {
                
          });	
      },



      //修改打印面单高度
      changeprintheight() {
          //if(!Number(this.printheight)) {this.$message.error('请设置正确的电子面单高度');return false;}
          this.$cookies.set('printsetheight',this.printheight);
          
      },

      //修改打印面单边距
      changeprinttop() {
          //if(!Number(this.printmargintop)) {this.$message.error('请设置正确的电子面单边距');return false;}
          this.$cookies.set('printsetmargintop',this.printmargintop);
      },

      //修改面单水平边距
      changeprintpadding() {
          //if(!Number(this.printpadding)) {this.$message.error('请设置正确的电子面单水平边距');return false;}
          this.$cookies.set('printpadding',this.printpadding);
      },

      
      //关闭打印界面
      YTO_model_close() {
          this.YTO_model1=false;
          this.YTO_model1_data=[];
      },

      //关闭打印界面
      ZTO_model_close() {
          this.ZTO_model1=false;
          this.ZTO_model1_data=[];
      },


      //取出电子面单进行打印
      printshippinglists() {
           
           //提取打印单子的快递信息
           var _this=this;
           this.printbirlds=[];
           var results={};
           this.selllogisticslists.forEach(function(e,index) {
               e.shippings.forEach(function(ee,ii) {
                   results[ee.logisticsid]={id:ee.logisticsid,name:ee.logisticsname,code:ee.logisticscode};
               });
           });
           for(var i in results) {
               this.printbirlds.push({id:results[i].id,name:results[i].name,code:results[i].code});
           } 
           if(this.printbirlds.length > 1) { //订单里大于一种快递时要选择快递打印面单
               this.printbirldsinfos.logisticsid='';
               this.printbirldsinfos.dialog=true;
               return false;
           }

           if(this.selllogisticslists.length==0) {this.$message.error('请选择相应的销售出库单');return false;}           
           var ids=[];
           this.selllogisticslists.forEach(function(e,index) {ids.push(e.id)});
           this.$confirm('您是否要将当前选中的销售单打印成电子面单 ? ', '提示', {type: 'warning' }).then(() => {
                var resource = this.$resource(this.url);
                resource.save({act:'getprintsellorders',token:this.$cookies.get('token'),sellids:ids.join(","),isprintgoods:this.isprintgoods,logisticsid:this.printbirlds[0].id}).then((res) => {
                    if(res.data.Result>0){
                        if(res.data.Result=='70001') this.$router.push('/login')
                        this.$message.error(res.data.Message);
                    }else{
                        var result=JSON.parse(Base64.decode(res.data.Data));
                        if(this.printbirlds[0].code=='YHTO') { //圆通快递模板
                            this.YTO_model1=true;
                            this.YTO_model1_data=result;

                        }else if(this.printbirlds[0].code=='ZTO') { //中通快递模板
                            this.ZTO_model1=true;
                            this.ZTO_model1_data=result;
                        }
                        
                    }
                }).catch((res) => {
                            
                });   

           }).catch(() => {
               
           })
      },


      //选择单个快递进行面单打印
      shippingprint() {
          if(this.printbirldsinfos.logisticsid=='') {this.$message.error('请选择要打印面单的快递');return false;}
          if(this.selllogisticslists.length==0) {this.$message.error('请选择相应的销售出库单');return false;}           
          var ids=[];
          this.selllogisticslists.forEach(function(e,index) {ids.push(e.id)});

          this.printbirldsinfos.dialog=false;
          var resource = this.$resource(this.url);
          resource.save({act:'getprintsellorders',token:this.$cookies.get('token'),sellids:ids.join(","),isprintgoods:this.isprintgoods,logisticsid:this.printbirldsinfos.logisticsid}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  var result=JSON.parse(Base64.decode(res.data.Data));
                  var logisticscode='';
                  var _this=this;
                  this.birldlists.forEach(function(e,index) {
                      if(e.id==_this.printbirldsinfos.logisticsid) logisticscode=e.shippingcode;
                  });

                  if(logisticscode=='YHTO') { //圆通快递模板
                        this.YTO_model1=true;
                        this.YTO_model1_data=result;

                  }else if(logisticscode=='ZTO') { //中通快递模板
                        this.ZTO_model1=true;
                        this.ZTO_model1_data=result;
                  }

              }
          }).catch((res) => {
                            
          });   

      },





      //解析地址信息
      analasyaddress() {
          this.$confirm('请选择匹配数据类型 ? ', '提示', {confirmButtonText: '修改销售单下所有快递',cancelButtonText:'修改指定快递', type: 'warning' }).then(() => {
                var resource = this.$resource(this.url);
                resource.save({act:'matchaddressfrominput',token:this.$cookies.get('token'),sellid:this.sellid,logisticsid:this.logisticsid,logisticsname:this.logisticsname,type:this.type,part:'all'}).then((res) => {
                    if(res.data.Result>0){
                        if(res.data.Result=='70001') this.$router.push('/login')
                        this.$message.error(res.data.Message);
                    }else{
                        this.getsellandorders();
                        this.changeDialog=false;
                    }
                }).catch((res) => {
                    
                });   
          }).catch(() => {
                var resource = this.$resource(this.url);
                resource.save({act:'matchaddressfrominput',token:this.$cookies.get('token'),sellid:this.sellid,logisticsid:this.logisticsid,logisticsname:this.logisticsname,type:this.type,part:'part'}).then((res) => {
                    if(res.data.Result>0){
                        if(res.data.Result=='70001') this.$router.push('/login')
                        this.$message.error(res.data.Message);
                    }else{
                        this.getsellandorders();
                        this.changeDialog=false;
                    }
                }).catch((res) => {
                    
                });   
          })
      },


      //编辑发货人地址信息
      getaddressinfos(sellid,logid,type) {
          this.sellid=sellid;
          this.logisticsid=logid;
          this.type=type;
          
          this.changeDialog=true;
          this.logisticsname='';
      },

      //删除出库单
      delsells(item) {
          var _this=this;
          var number=-1;
          var sellids=[];
          this.selllogisticslists.forEach(function(e,i) {
              if(item.id==e.id) {
                  number=i; 
              }else {
                  sellids.push(e.id);
              }
          });

          if(number > -1) this.$delete(this.selllogisticslists,number);
          this.query.sellids=sellids.join(",");
      },

      //新增快递单信息
      addlogisticstosells(loginfos) {
          this.$confirm('您是需要对该销售出库单新增快递单 ? ', '提示', { type: 'warning' }).then(() => {

                if(this.birldlists.length > 1) {
                    this.showbirld.loginfosid=loginfos.id;
                    this.showbirld.id='';
                    this.showbirld.dialog=true;
                    return false;
                }

                var resource = this.$resource(this.url);
                resource.save({act:'addshippingtosell',token:this.$cookies.get('token'),id:loginfos.id}).then((res) => {
                    if(res.data.Result>0){
                        if(res.data.Result=='70001') this.$router.push('/login')
                        this.$message.error(res.data.Message);
                    }else{
                        this.getsellandorders();
                    }
                }).catch((res) => {
                    
                });   

          }).catch(() => {
        	
          })
      },


      //保存新增的快递信息
      sellselectshipping() {
          if(this.showbirld.id=='') {this.$message.error("请选择快递方式");return false;}

          var resource = this.$resource(this.url);
          resource.save({act:'addshippingtosell',token:this.$cookies.get('token'),id:this.showbirld.loginfosid,shippingid:this.showbirld.id}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.showbirld.dialog=false;
                  this.getsellandorders();
              }
          }).catch((res) => {
                    
          });   
      },





      //删除快递信息
      delshippings(sellid,item) {
          var resource = this.$resource(this.url);
          resource.save({act:'delshippingfromsell',token:this.$cookies.get('token'),sellid:sellid,id:item.id}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.getsellandorders();
              }
          }).catch((res) => {
                    
          });   
      },


      //获取销售出库单对应电子面单
      getsellandorders() {
          this.query.loading=true;
          var resource = this.$resource(this.url);
          resource.save(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.query.loading=false;
              }else{
                  this.selllogisticslists=JSON.parse(Base64.decode(res.data.Data));
                  this.query.loading=false;
              }
          }).catch((res) => {
              this.query.loading=false;
          });	
      },

      //关闭当前的快递单页面
      closeshipping() {
          this.view=false;
          this.$emit('close');
      },

  },

}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.print-shipping-documents {display:inline-block;width:100%;font-size:13px;color:#333333}
.print-shipping-id {display:inline-block;width:100%;font-size:12px;color:#999999;font-style:itatic;}
.shipping-print-infos {padding:5px;background:rgba(221,221,221,.3);border:1px dashed #666666;cursor:pointer;border-radius:5px}
.print-express-time {font-size:13px;font-weight:550;color:#000000;display:inline-block;margin:10px 0 0 5%;margin-top:10px;}
.print-express-area {display:inline-block;padding:5px 0 2px 0;margin:0 5%;width:90%;font-size:23px;font-weight:550;color:#000000;border-bottom:2px solid #000000;text-align:center;}
.codeout {display:inline-block;width:90%;margin:5px 5% 0 5%;text-align:center;border-bottom:2px solid #000000;line-height:23px;}
.codeout img {width:80%;}
.print-express-address {display:inline-block;width:90%;margin:0 5%;}
.print-express-name {display:inline-block;width:100%;border-bottom:2px solid #000000;color:#000000;font-size:18px;font-weight:550;padding:10px 0;}
.print-express-reciever {float:left;width:100%;border-bottom:2px solid #000000;}
.print-express-reciever-left {float:left;width:15%;display:flex;justify-content:center;align-items:center;}
.print-express-reciever-left span {font-size:15px;color:#000000;font-weight:550;}
.print-express-reciever-right {float:left;border-left:2px solid #000000;width:calc(100% - 15% - 6px);padding:5px 2px;}
.print-express-reciever-name-phone {float:left;width:100%;font-size:13px;line-height:18px;color:#000000}
.sz {font-size:12px;}
.print-express-bottom {display:inline-block;width:100%;margin:10px 0 0 0;border-bottom:2px solid #000000;}
.print-express-bottom-info {width:100%;font-size:12px;line-height:18px;font-weight:550;color:#000000}
.print-express-sell {display:inline-block;width:90%;margin:0 0 0 5%;font-size:14px;line-height:15px;font-weight:550;font-weight:550;}
.YTO-model-temps .el-form-item__content {width:65%}

.print-express-main-YTO {width:80%;height:130mm;margin:auto;position:relative;}
.express-YTO-time {width:90%;font-size:13px;color:#000;border-bottom:1px solid #000;text-align:left;line-height:14px;font-weight:100;margin:auto;margin-top:40px;}
.express-YTO-img {width:85%;border-bottom:1px solid #000;text-align:center;line-height:21px;margin:0 auto}
.express-YTO-img img {width:80%;margin-top:5px}
.express-YTO-area {width:85%;margin:0 auto;}
.express-YTO-area-left {float:left;display:flex;justify-content:center;align-items:center;height:45px;border-right:1px solid #000000;}
.express-YTO-area-left span {font-size:20px;font-weight:550;}
.express-YTO-area-code {width:85%;margin:0 auto;border-top:1px solid #000000;text-align:center;font-size:28px;font-weight:550;padding:5px 0;clear:both;}
.express-YTO-sender {width:85%;margin:0 auto;border-bottom:1px solid #000;clear:both}
.express-YTO-sender-left {width:25%;height:60px;float:left;display:flex;justify-content:center;align-items:center;}
.express-YTO-sender-left span {font-size:15px;line-height:14px;padding:5px;border-radius:50%;color:#000;font-weight:550;border:2px solid #000;}
.express-YTO-sender-right {width:75%;height:60px;float:left;}
.express-YTO-sender-right-content {float:left;width:100%;font-size:14px;line-height:16px;font-weight:530}
.express-YTO-reciever {width:85%;margin:0 auto;border-top:1px solid #000;clear:both;}
.express-YTO-reciever-left {width:25%;height:60px;float:left;display:flex;justify-content:center;align-items:center;}
.express-YTO-reciever-left span {font-size:14px;line-height:14px;padding:5px;border-radius:50%;color:#000;font-weight:550;border:2px solid #000;}
.express-YTO-reciever-right {width:75%;height:60px;float:left;}
.express-YTO-reciever-right-content {float:left;width:100%;font-size:13px;line-height:21px;font-weight:530;font-size:13px}
.express-YTO-bottom {width:85%;margin:0 auto;border-top:1px solid #000;clear:both;}
.express-YTO-bottom-left {float:left;width:30%;height:70px;border-right:1px solid #000;display:flex;justify-content:center;align-items:center;}
.express-YTO-bottom-left span {font-size:20px;font-weight:550;}
.express-YTO-bottom-right {float:left;width:calc(70% - 1px);height:70px;display:flex;justify-content:center;align-items:center;}
.express-YTO-bottom-right img  {max-width:80%}
.express-YTO-sell {width:85%;margin:0 auto;border-top:1px solid #000;clear:both;font-size:15px;padding-top:2px;font-weight:530}
</style>


// WEBPACK FOOTER //
// src/components/home/print/logisticsprint.vue